import * as Sentry from '@sentry/react';

export function initSentry() {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      
      // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      
      // Filter out sensitive data
      beforeSend(event, hint) {
        // Remove user email if present
        if (event.user) {
          delete event.user.email;
          delete event.user.username;
        }
        
        // Filter out any URLs with tokens
        if (event.request?.url) {
          event.request.url = event.request.url.replace(/([?&])(access_token|refresh_token|token)=[^&]*/gi, '$1$2=***');
        }
        
        return event;
      },
      
      // Don't send errors from localhost
      beforeSendTransaction(event) {
        if (event.request?.url?.includes('localhost')) {
          return null;
        }
        return event;
      },
    });
  }
}

// Export utility function for manual error reporting
export function captureError(error: Error, context?: Record<string, any>) {
  if (import.meta.env.PROD) {
    Sentry.captureException(error, {
      extra: context,
    });
  } else {
    // In development, log to console for debugging
    console.error('[Dev Error]', error, context);
  }
}

// Export utility function for capturing messages
export function captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
  if (import.meta.env.PROD) {
    Sentry.captureMessage(message, level);
  }
}
